import { ExternalAgentIdentifier } from '@/types/general';
import { PostalAddress } from '@/types/address';

interface Functions {
  uid: string;
  function: 'all_rights';
  roleUid: string;
}

export interface NaturalPersonDetails {
  isPassported?: boolean;
  isRegistered?: boolean;
  isDeclared?: boolean;
  isQualified?: boolean;
  isIdentificationOnly?: boolean;
  hasLimitedIdentity?: boolean;
}

export enum RoleAccessMode {
  All = 'all',
  Pending = 'pending',
  Granted = 'granted'
}

export interface Delegate {
  personUid: string;
  personIdentityUID?: string;
  processingStatus: {
    expirationTime?: Date;
    status: string;
    verifications?: Record<string, string>;
  };
  name: string;
  requestedName?: string;
  hasConfirmed?: boolean;
  isConfirmed?: boolean;
  confirmed?: boolean;
  inReduction?: boolean;
  empowerment: string;
  role: string;
  status: string;
  weight: number;
  threshold: number;
  matchingName?: boolean;
  matchingDomicile?: boolean;
  matchingMandate?: {
    mandatee?: {
      personIds?: ExternalAgentIdentifier[];
      firstname?: string;
      lastname?: string;
      title?: string;
      domicile?: PostalAddress;
      gender?: string;
      hometown?: string;
    };
    empowerment?: string;
  };
  partnerAsDelegate?: boolean;
  withAdminRole?: boolean;
  withAllRightsFunction?: boolean;
  requestedAsDelegate?: boolean;
  registeredOnly?: boolean;
  functions?: Functions[];
  extensionOrderUid?: string;
  reductionOrderUid?: string;
  agentRoleInContractUid?: string;
  identificationContextUid?: string;
  voucherCode?: string;
  voucherCodeValidUntil?: Date;
  personDetails?: NaturalPersonDetails;
}
